// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".team_root__1MTiv {\n  background: #fafafa;\n  display: flex;\n  justify-content: center;\n  height: 100%; }\n  .team_root__1MTiv .team_content__2FYB_ {\n    width: calc(100% - 73px);\n    height: calc(100% - 60px);\n    min-height: 300px;\n    padding: 20px;\n    background: #fff;\n    border-radius: 15px;\n    overflow: auto;\n    box-shadow: 2px 1px 11px 3px rgba(181, 181, 181, 0.4);\n    margin-top: 10px; }\n", ""]);
// Exports
exports.locals = {
	"root": "team_root__1MTiv",
	"content": "team_content__2FYB_"
};
module.exports = exports;
